import { FC } from 'react';
import dynamic from 'next/dynamic';

import { Logger } from 'lib/logger';
import { AuthProviders } from 'constants/enums';

import { ProviderInterface } from '../config/declarations';

const Facebook = dynamic(() => import('./Facebook'));
const Google = dynamic(() => import('./Google'));
const Apple = dynamic(() => import('./Apple'));

const Button: FC<ProviderInterface> = ({ provider, ...rest }) => {
  switch (provider) {
    case AuthProviders.FACEBOOK: {
      return <Facebook {...rest} />;
    }
    case AuthProviders.APPLE: {
      return <Apple {...rest} />;
    }
    case AuthProviders.GOOGLE: {
      return <Google {...rest} />;
    }
    default: {
      Logger.warn('No auth providers found');

      return null;
    }
  }
};

export default Button;
